import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="bg-gradient-to-br from-blue-500 to-indigo-600 py-16">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
          Let's make safety smarter together
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/signup" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-medium flex items-center gap-2 hover:bg-blue-50 transition-colors">
            Lets' Go <ArrowRight size={20} />
          </Link>
          <a href="#footer" className="border-2 border-white text-white px-8 py-3 rounded-lg font-medium flex items-center gap-2 hover:bg-white/10 transition-colors">
            Talk to an Expert
          </a>
        </div>
      </div>
    </section>
  );
}